import PropTypes from 'prop-types';
import ExpandCollapseButton from "../../../components/expand-collapse-button/expand-collapse-button";
import { GetMergersAndAcquisitionsData, GetMergersAndAcquisitionsExcelExport, UpdateMergersLastUpdated } from "../../../services/api/dashboard-api";
import FluentUiIcon from '../../../assets/fluent-ui-icon';
import { FluentButton } from '../../../components/FluentUI/Fluent-Button';
import { useFluentToast } from "../../../components/FluentUI/Fluent-Toast";
import { useState } from 'react';

const DashboardTableHeader = ({ type, accordionId, collapsed, setCollapsed, toggled, setToggled,juniorBankerView, DealsTaskId,setUsers }) => {
    const [loading, setLoading] = useState(false);
    const { showToast, FluentToast } = useFluentToast("bottom-start",true);
    const title = type.toLowerCase() === "associate" ? "Associate" : "Analyst";
    const formattedDate = new Date().toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });
    const UpdateLastUpdated = async () => {
        setLoading(true);
        try {
            let result = await UpdateMergersLastUpdated(DealsTaskId);        
            if (result.status === 200) {
                let refreshedUsers = await GetMergersAndAcquisitionsData(title);
                setLoading(false);
                if (refreshedUsers?.status === 200){
                    setUsers(refreshedUsers?.data);
                    showToast(
                        "Task Updated Succesfully",
                        `The Task has been succesfully updated on ${formattedDate}`,
                        "success"                          
                    );
                }            
            }    
            else{
                setLoading(false);
            }
        } catch (error) {
            console.error("Error updating last updated:", error);
            setLoading(false);
        }
        
    };

    return (
        <th className="DashboardTableTitle">
            {`Time Tracker - ${title}`}
            <div className="DashboardTableHeaderButtons" style={{gap: '10px'}}>         
               {juniorBankerView && 
               <div>
                    <div className='position-relative'> 
                        {FluentToast}
                    </div>
                    <FluentButton
                         icon={<FluentUiIcon name={'ThumbLikeRegular'} color={loading ? 'grey' :'#0F6CBD'} size={20} />}
                         text="Indicate No Update"
                         onClick={() => UpdateLastUpdated()}
                         disabled={loading}
                         id = {"mergersExport"}
                     /> 
                  
               </div>}       
                <FluentButton
                    icon={<FluentUiIcon name={'ArrowDownloadRegular'} color={'#0F6CBD'} size={20} />}
                    text="Export Data"
                    onClick={() => GetMergersAndAcquisitionsExcelExport(type)}
                />
                {!juniorBankerView && <ExpandCollapseButton className="expand-collapse-button-test"
                    accordionId={accordionId}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    toggled={toggled}
                    setToggled={setToggled}
                />}
            </div>
            <p className="subDepartmentTitle">{`Mergers & Acquisitions`}</p>
        </th>
    );
};

DashboardTableHeader.propTypes = {
    type: PropTypes.oneOf(['associate', 'analyst']).isRequired,
    accordionId: PropTypes.string.isRequired,
    collapsed: PropTypes.bool.isRequired,
    setCollapsed: PropTypes.func.isRequired,
    toggled: PropTypes.array.isRequired,
    setToggled: PropTypes.func.isRequired,
    juniorBankerView: PropTypes.bool.isRequired,
    DealsTaskId: PropTypes.number.isRequired,
    setUsers: PropTypes.func.isRequired
};

export default DashboardTableHeader;
